import React, { useEffect, useState } from "react";
import "../styles/MembershipManagement.css";
import { PiAddressBookTabs } from "react-icons/pi";
import { IoSearch } from "react-icons/io5";
import GymTable from "../components/GymTable";
import axios from "axios";
import API_URL from "../config";
import { useAdmin } from "../contexts/AdminContext";
import Loading from "../components/Loading";

const RenewalAlerts = () => {
  const { admin } = useAdmin();
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsersByBranch = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/auth/branch/${admin?.branch}`
        );
        setUsers(response.data);
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsersByBranch();
  }, []);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredUsers = users.filter((user) => {
    const trainerId = user.trainerId?.toLowerCase() || "";
    return trainerId.includes(searchTerm.toLowerCase());
  });

  return (
    <div className="membershipManagementContainer">
      <div className="membershipManagementHeader">
        <div className="memberHeaderLeft">
          <PiAddressBookTabs
            size={30}
            color="#ff0000"
            style={{ marginRight: 10 }}
          />
          <h2>Renewal Alerts</h2>
        </div>
        <div className="memberHeaderRight">
          <input
            placeholder="eg. Search by trainer name"
            onChange={handleSearchChange}
          />
          <div>
            <IoSearch />
          </div>
        </div>
      </div>
      <div className="userMemberContainer" style={{ marginLeft: 20 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h3>Renewal Alerts:</h3>
          <p style={{ cursor: "pointer" }}>View All</p>
        </div>
        {loading ? (
          <Loading />
        ) : (
          <GymTable
            data={filteredUsers}
            allexpired={true}
            isAll={true}
            trainer={true}
          />
        )}
      </div>
    </div>
  );
};

export default RenewalAlerts;
